// Acceso biométrico dentro de la pantalla de login de Frappe.
//
// Un solo botón que despliega las dos opciones y las resuelve AQUÍ, sin navegar:
//   · Huella: SDK del lector (ya viene en web_include_js del portal).
//   · Cara:   cámara + MediaPipe (parpadeo) cargados bajo demanda desde los
//             mismos assets que usa el kiosko de las TC21.
// Sólo aparece si este equipo está dado de alta como Dispositivo y está Activo;
// lo confirma el servidor, no el navegador.
(function () {
	// El mismo formulario se sirve en /login y en la raiz del sitio (y Frappe
	// tambien usa /app/login), asi que el boton debe aparecer en las tres.
	var ruta = window.location.pathname.replace(/\/+$/, "");
	if (ruta !== "" && ruta !== "/login" && ruta !== "/app/login") return;

	var params = new URLSearchParams(window.location.search);
	if (params.get("bypass") === "face") return;

	// El identificador del equipo se guarda por dominio. Si se entra por una
	// direccion distinta (o tras limpiar los datos del sitio) se puede vincular
	// pasandolo en la URL una vez: .../?serial=PC-LO-QUE-SEA
	var serial = "";
	try {
		var deUrl = (params.get("serial") || "").trim();
		if (deUrl) localStorage.setItem("calzins_face_serial", deUrl);
		serial = deUrl || (localStorage.getItem("calzins_face_serial") || "").trim();
	} catch (e) {
		return;
	}
	if (!serial) return;

	var BASE_FACE = "/assets/iopgps_sync/face/";
	var THRESH_BLINK = 0.5, THRESH_OPEN = 0.25, NEED_BLINKS = 1;

	function destino() {
		var rt = params.get("redirect-to");
		return rt && rt.charAt(0) === "/" ? rt : "/app";
	}

	var ICONO_CARA =
		'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
		'<path d="M3 8V5a2 2 0 0 1 2-2h3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M8 21H5a2 2 0 0 1-2-2v-3"/>' +
		'<circle cx="9" cy="10" r="1"/><circle cx="15" cy="10" r="1"/><path d="M9 15c.8.7 1.9 1 3 1s2.2-.3 3-1"/></svg>';
	var ICONO_HUELLA =
		'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
		'<path d="M12 11c0 3.5-1 6.8-2.75 9.6"/><path d="M5.8 18.5A13.9 13.9 0 0 0 8 11a4 4 0 1 1 8 0c0 1-.07 2-.2 3"/>' +
		'<path d="M13.7 20.8A21.9 21.9 0 0 0 15.2 17"/><path d="M19 18.1c.65-2.3 1-4.7 1-7.1A8 8 0 0 0 8 4.07"/>' +
		'<path d="M3 15.4c.64-1.3 1-2.8 1-4.4 0-1.5.39-2.8 1.07-4"/></svg>';

	var CSS = [
		".bio-wrap{margin-top:14px}",
		".bio-sep{text-align:center;margin:14px 0 10px;color:var(--text-muted,#8d99a6);font-size:12px}",
		".bio-main{display:flex;align-items:center;justify-content:center;gap:8px;transition:opacity .22s ease,transform .22s ease}",
		".bio-main svg{width:18px;height:18px}",
		".bio-main.oculto{opacity:0;transform:scale(.98);pointer-events:none;position:absolute;left:-9999px}",
		".bio-panel{overflow:hidden;max-height:0;opacity:0;transform:translateY(-6px);",
		"  transition:max-height .45s cubic-bezier(.22,1,.36,1),opacity .3s ease,transform .45s cubic-bezier(.22,1,.36,1)}",
		".bio-panel.abierto{max-height:460px;opacity:1;transform:translateY(0)}",
		".bio-ops{display:grid;grid-template-columns:1fr 1fr;gap:10px;transition:opacity .25s ease,max-height .35s ease}",
		".bio-ops.oculto{opacity:0;max-height:0;overflow:hidden;pointer-events:none}",
		".bio-op{display:flex;flex-direction:column;align-items:center;gap:7px;padding:16px 10px;",
		"  border:1px solid var(--border-color,#e2e6e9);border-radius:12px;background:var(--card-bg,#fff);",
		"  cursor:pointer;font-size:13px;font-weight:500;color:var(--text-color,#1f272e);",
		"  opacity:0;transform:translateY(10px) scale(.98);",
		"  transition:transform .2s ease,border-color .2s ease,box-shadow .2s ease}",
		".bio-panel.abierto .bio-op{animation:bioEntra .44s cubic-bezier(.22,1,.36,1) forwards}",
		".bio-panel.abierto .bio-op:nth-child(2){animation-delay:.07s}",
		".bio-op:hover{border-color:var(--primary,#2490ef);box-shadow:0 2px 10px rgba(36,144,239,.15);transform:translateY(-1px)}",
		".bio-op svg{width:26px;height:26px;color:var(--primary,#2490ef)}",
		"@keyframes bioEntra{to{opacity:1;transform:translateY(0) scale(1)}}",
		// visor de cámara
		".bio-cam{display:none;margin-top:4px}",
		".bio-cam.activo{display:block;animation:bioEntra .4s cubic-bezier(.22,1,.36,1) forwards}",
		".bio-marco{position:relative;width:170px;height:210px;margin:0 auto;border-radius:50%/44%;",
		"  overflow:hidden;background:#0e1524;box-shadow:0 0 0 2px var(--border-color,#e2e6e9)}",
		".bio-marco.scan{box-shadow:0 0 0 2px var(--primary,#2490ef),0 0 22px rgba(36,144,239,.35)}",
		".bio-marco.ok{box-shadow:0 0 0 2px var(--green-600,#16a34a),0 0 22px rgba(22,163,74,.35)}",
		".bio-marco.bad{box-shadow:0 0 0 2px var(--red-500,#e24c4c)}",
		".bio-marco video{width:100%;height:100%;object-fit:cover;transform:scaleX(-1);opacity:0;transition:opacity .35s ease}",
		".bio-marco video.live{opacity:1}",
		".bio-barrido{position:absolute;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent,var(--primary,#2490ef),transparent);",
		"  animation:bioBarrido 2.4s ease-in-out infinite;opacity:.85}",
		"@keyframes bioBarrido{0%,100%{top:12%}50%{top:88%}}",
		".bio-spinner{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}",
		".bio-spinner:after{content:'';width:26px;height:26px;border:2px solid rgba(255,255,255,.25);",
		"  border-top-color:#fff;border-radius:50%;animation:bioGira .8s linear infinite}",
		"@keyframes bioGira{to{transform:rotate(360deg)}}",
		".bio-estado{margin-top:12px;text-align:center;font-size:13px;min-height:18px;color:var(--text-muted,#8d99a6)}",
		".bio-estado.error{color:var(--red-500,#e24c4c)}",
		".bio-estado.ok{color:var(--green-600,#16a34a)}",
		".bio-cancelar{display:block;margin:10px auto 0;background:none;border:0;color:var(--text-muted,#8d99a6);",
		"  font-size:12px;cursor:pointer;text-decoration:underline}",
		".bio-latido svg{animation:bioLatido 1.5s ease-in-out infinite}",
		"@keyframes bioLatido{0%,100%{opacity:.5}50%{opacity:1}}",
		"@media (prefers-reduced-motion:reduce){.bio-panel,.bio-op,.bio-main,.bio-cam{transition:none;animation:none}",
		"  .bio-panel.abierto .bio-op{opacity:1;transform:none}.bio-barrido{animation:none}}",
	].join("\n");

	var el = {};        // nodos del panel
	var cam = {         // estado del flujo facial
		landmarker: null, stream: null, corriendo: false, ocupado: false,
		parpadeos: 0, ojoAbierto: true, ultimoTs: 0,
	};

	function decir(txt, clase) {
		el.estado.textContent = txt || "";
		el.estado.className = "bio-estado" + (clase ? " " + clase : "");
	}

	function marco(clase) {
		el.marco.className = "bio-marco" + (clase ? " " + clase : "");
	}

	function api(metodo, datos) {
		return fetch("/api/method/" + metodo, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Frappe-CSRF-Token": window.csrf_token || "None",
			},
			credentials: "same-origin",
			body: JSON.stringify(datos || {}),
		})
			.then(function (r) { return r.json().catch(function () { return {}; }); })
			.then(function (j) { return j.message !== undefined ? j.message : j; });
	}

	// ---------------- cara ----------------
	async function abrir_camara() {
		el.ops.classList.add("oculto");
		el.cam.classList.add("activo");
		el.spinner.style.display = "flex";
		decir("Preparando la cámara…");

		try {
			if (!cam.landmarker) {
				var vision = await import(BASE_FACE + "vision_bundle.js");
				var fileset = await vision.FilesetResolver.forVisionTasks(BASE_FACE + "wasm");
				cam.landmarker = await vision.FaceLandmarker.createFromOptions(fileset, {
					baseOptions: { modelAssetPath: BASE_FACE + "face_landmarker.task" },
					runningMode: "VIDEO", numFaces: 1, outputFaceBlendshapes: true,
				});
			}
		} catch (e) {
			el.spinner.style.display = "none";
			return decir("No se pudo cargar el modelo de rostro.", "error");
		}

		try {
			cam.stream = await navigator.mediaDevices.getUserMedia({
				video: { facingMode: "user", width: { ideal: 640 }, height: { ideal: 480 } },
				audio: false,
			});
			el.video.srcObject = cam.stream;
			el.video.muted = true;
		} catch (e) {
			el.spinner.style.display = "none";
			return decir("Sin acceso a la cámara. Autorízala en el navegador.", "error");
		}

		for (var i = 0; i < 10; i++) {
			try { await el.video.play(); } catch (e) {}
			if (el.video.videoWidth > 0 && !el.video.paused) break;
			await new Promise(function (r) { setTimeout(r, 200); });
		}

		el.spinner.style.display = "none";
		el.video.classList.add("live");
		marco("scan");
		cam.corriendo = true;
		cam.parpadeos = 0; cam.ojoAbierto = true; cam.ocupado = false;
		cam.desde = 0; cam.trazado = 0; cam.fase = "parpadeo";
		decir("Mira a la cámara");
		siguiente_cuadro();
	}

	// apertura de los ojos a partir de los landmarks (eye aspect ratio)
	function apertura_ojos(lm) {
		if (!lm) return null;
		var d = function (a, b) { return Math.hypot(a.x - b.x, a.y - b.y); };
		try {
			var i = d(lm[159], lm[145]) / (d(lm[33], lm[133]) || 1e-6);
			var de = d(lm[386], lm[374]) / (d(lm[362], lm[263]) || 1e-6);
			return (i + de) / 2;
		} catch (e) { return null; }
	}

	function siguiente_cuadro() {
		if (!cam.corriendo) return;
		var paso = function () { detectar(); if (cam.corriendo) siguiente_cuadro(); };
		if (el.video.requestVideoFrameCallback) el.video.requestVideoFrameCallback(paso);
		else requestAnimationFrame(paso);
	}

	function detectar() {
		if (!cam.corriendo || !cam.landmarker || el.video.videoWidth === 0) return;
		// en fase de gesto el bucle sigue vivo SOLO para refrescar los landmarks:
		// si dejara pasar el resto, pisaria el texto del reto y volveria a llamar
		// a reconocer(), que era lo que hacia "saltar" el reto sin darte tiempo
		if (cam.fase !== "gesto" && cam.ocupado) return;
		var ts = performance.now();
		if (ts <= cam.ultimoTs) ts = cam.ultimoTs + 1;
		cam.ultimoTs = ts;

		var res = null;
		try { res = cam.landmarker.detectForVideo(el.video, ts); } catch (e) { return; }
		var hayRostro = res && res.faceLandmarks && res.faceLandmarks.length > 0;
		if (hayRostro) cam.ultimoRes = res;
		if (cam.fase === "gesto") return;          // nada mas durante el gesto
		if (!hayRostro) return decir("No detecto un rostro");

		var cats = (res.faceBlendshapes && res.faceBlendshapes[0] && res.faceBlendshapes[0].categories) || [];
		var izq = 0, der = 0;
		cats.forEach(function (c) {
			if (c.categoryName === "eyeBlinkLeft") izq = c.score;
			else if (c.categoryName === "eyeBlinkRight") der = c.score;
		});
		var b = (izq + der) / 2;
		var fuente = "blendshapes";
		if (!cats.length) {
			// algunos navegadores no entregan blendshapes: se calcula con los
			// propios landmarks (apertura de los ojos)
			var e = apertura_ojos(res.faceLandmarks[0]);
			b = e === null ? 0 : Math.max(0, Math.min(1, (0.26 - e) / 0.16));
			fuente = "landmarks";
		}
		if (!cam.trazado || performance.now() - cam.trazado > 1000) {
			cam.trazado = performance.now();
			if (window.console) console.log("[bio] cierre de ojos", b.toFixed(2), "via", fuente);
		}
		if (b > THRESH_BLINK && cam.ojoAbierto) cam.ojoAbierto = false;
		else if (b < THRESH_OPEN && !cam.ojoAbierto) { cam.ojoAbierto = true; cam.parpadeos++; }

		cam.ultimoRes = res;
		// El parpadeo solo elige cuando capturar: la prueba de vida real es el
		// gesto que pide y verifica el servidor. Si no se detecta (camara pobre,
		// lentes, API recortada) se continua igual en vez de dejar atorado.
		if (!cam.desde) cam.desde = performance.now();
		var esperando = performance.now() - cam.desde;
		if (cam.parpadeos >= NEED_BLINKS || esperando > 6000) {
			cam.corriendo = false;
			if (window.console && cam.parpadeos < NEED_BLINKS) console.log("[bio] sin parpadeo en 6 s, se continua");
			reconocer();
		} else {
			decir(esperando > 2500 ? "Parpadea para continuar…" : "Parpadea para continuar");
		}
	}

	function tomar_foto() {
		var lienzo = document.createElement("canvas");
		lienzo.width = el.video.videoWidth || 640;
		lienzo.height = el.video.videoHeight || 480;
		lienzo.getContext("2d").drawImage(el.video, 0, 0, lienzo.width, lienzo.height);
		return lienzo.toDataURL("image/jpeg", 0.9);
	}

	// Cuánto se desvía del frente el rostro actual, con landmarks: sirve para
	// elegir el mejor cuadro del gesto. Quien decide si el gesto vale es el
	// servidor (con la pose de CompreFace); esto solo escoge cuándo disparar.
	function desvio(reto) {
		var res = cam.ultimoRes;
		var lm = res && res.faceLandmarks && res.faceLandmarks[0];
		if (!lm) return 0;
		var ojoIzq = lm[33], ojoDer = lm[263], nariz = lm[1], menton = lm[152];
		if (!ojoIzq || !ojoDer || !nariz) return 0;
		var anchoOjos = Math.abs(ojoDer.x - ojoIzq.x) || 0.0001;
		if (reto === "gira_lado") {
			var centro = (ojoIzq.x + ojoDer.x) / 2;
			return Math.abs(nariz.x - centro) / anchoOjos;      // nariz fuera del centro
		}
		if (reto === "mira_arriba" || reto === "mira_abajo") {
			var lineaOjos = (ojoIzq.y + ojoDer.y) / 2;
			var alto = Math.abs((menton ? menton.y : 1) - lineaOjos) || 0.0001;
			var rel = (nariz.y - lineaOjos) / alto;             // nariz sube o baja
			return reto === "mira_arriba" ? -rel : rel;
		}
		if (reto === "acercate") return anchoOjos;              // el rostro crece
		return 0;
	}

	function esperar(ms) {
		return new Promise(function (r) { setTimeout(r, ms); });
	}

	async function capturar_gesto(reto, texto) {
		decir(texto + "…");
		marco("scan");
		// OJO: `ocupado` corta detectar(), así que hay que soltarlo mientras se
		// muestrea el gesto o los landmarks se quedan congelados en el cuadro
		// frontal y se enviaría una cara de frente como si fuera el gesto.
		cam.fase = "gesto";
		cam.ocupado = false;
		cam.corriendo = true;
		siguiente_cuadro();

		await esperar(250);                      // deja llegar el primer cuadro
		var base = desvio(reto);
		var mejor = null, mejorVal = -Infinity, logrado = false;
		for (var i = 0; i < 26; i++) {           // hasta ~8 s de muestreo
			await esperar(300);
			var restan = Math.ceil((26 - i) * 0.3);
			var bruto = desvio(reto);
			var val = reto === "acercate" ? bruto / (base || 1) - 1 : bruto - base;
			if (val > mejorVal) { mejorVal = val; mejor = tomar_foto(); }
			var meta = reto === "acercate" ? 0.35 : (reto === "gira_lado" ? 0.45 : 0.28);
			if (val >= meta) { logrado = true; decir("¡Así! Verificando…"); break; }
			decir(texto + " · " + restan + " s");
		}
		cam.corriendo = false;
		cam.ocupado = true;
		cam.fase = "envio";
		if (window.console) console.log("[bio] gesto", reto, "desvio", mejorVal.toFixed(2), logrado ? "ok" : "flojo");
		return mejor || tomar_foto();
	}

	async function reconocer() {
		cam.ocupado = true;
		marco("ok");
		decir("Reconociendo…");

		var imagen = tomar_foto();

		var rn = await api("iopgps_sync.turnos.face_login.face_login_nonce", { serial: serial });
		if (!rn || !rn.ok) return rechazar((rn && rn.msg) || "No autorizado");

		// el servidor pide un gesto al azar y lo verifica con la pose real
		var imagenReto = null;
		if (rn.reto) imagenReto = await capturar_gesto(rn.reto, rn.reto_texto || "Haz el gesto");

		decir("Verificando…");
		var r1 = await api("iopgps_sync.turnos.face_login.face_login",
			{ image: imagen, serial: serial, nonce: rn.nonce, image_reto: imagenReto });
		if (!r1 || !r1.ok) {
			var extra = r1 && r1.similarity !== undefined ? " (parecido " + r1.similarity + " de " + r1.umbral + ")" : "";
			if (r1 && r1.detalle) extra = " (" + r1.detalle + ")";
			return rechazar(((r1 && r1.msg) || "Cara no reconocida") + extra);
		}

		decir("Hola " + (r1.employee_name || "") + ", entrando…", "ok");
		var r2 = await api("iopgps_sync.turnos.face_login.face_login_exchange",
			{ code: r1.code, serial: serial });
		if (!r2 || !r2.ok) return rechazar((r2 && r2.msg) || "No se pudo iniciar sesión");

		apagar_camara();
		setTimeout(function () { window.location.href = destino(); }, 500);
	}

	function rechazar(msg) {
		marco("bad");
		decir(msg, "error");
		cam.ocupado = false;
		setTimeout(function () {
			if (!cam.stream) return;
			cam.parpadeos = 0; cam.ojoAbierto = true; cam.corriendo = true;
			cam.desde = 0; cam.fase = "parpadeo";
			marco("scan");
			decir("Intenta otra vez: mira a la cámara");
			siguiente_cuadro();
		}, 2200);
	}

	function apagar_camara() {
		cam.corriendo = false;
		try {
			if (cam.stream) cam.stream.getTracks().forEach(function (t) { t.stop(); });
		} catch (e) {}
		cam.stream = null;
		el.video.srcObject = null;
		el.video.classList.remove("live");
		el.cam.classList.remove("activo");
		marco("");
	}

	// ---------------- huella ----------------
	async function entrar_con_huella(boton) {
		var fp = window.frappe && window.frappe.fingerprint;
		if (!fp) return decir("El lector no está disponible en este equipo.", "error");

		boton.classList.add("bio-latido");
		decir("Buscando el lector…");

		var listo = false;
		try { listo = await fp.is_bridge_available(); } catch (e) { listo = false; }
		if (!listo) {
			boton.classList.remove("bio-latido");
			return decir("Lector no detectado. Conéctalo y vuelve a intentar.", "error");
		}

		var rn = await api("fingerprint_auth.api.verify.get_verification_nonce", {});
		if (!rn || !rn.nonce) {
			boton.classList.remove("bio-latido");
			return decir("No se pudo iniciar. Intenta de nuevo.", "error");
		}

		decir("Coloca tu dedo en el lector…");
		var captura = null;
		try { captura = await fp.capture(); }
		catch (e) {
			boton.classList.remove("bio-latido");
			return decir((e && e.message) || "No se pudo leer la huella.", "error");
		}

		decir("Verificando…");
		var r = await api("fingerprint_auth.api.verify.fingerprint_login",
			{ template_b64: captura.template_b64, nonce: rn.nonce });
		boton.classList.remove("bio-latido");

		if (r && r.verified) {
			decir("Bienvenido, " + (r.full_name || "") + "…", "ok");
			setTimeout(function () { window.location.href = destino(); }, 700);
		} else {
			decir("Huella no reconocida. Intenta otra vez.", "error");
		}
	}

	// ---------------- montaje ----------------
	function pintar() {
		var caja = document.querySelector(".page-card-body") || document.querySelector(".page-card");
		if (!caja || document.getElementById("bio-wrap")) return;

		var estilo = document.createElement("style");
		estilo.textContent = CSS;
		document.head.appendChild(estilo);

		var wrap = document.createElement("div");
		wrap.id = "bio-wrap";
		wrap.className = "bio-wrap";
		wrap.innerHTML =
			'<div class="bio-sep">o</div>' +
			'<button type="button" id="bio-main" class="btn btn-default btn-block bio-main">' +
			ICONO_CARA + "<span>Acceso biométrico</span></button>" +
			'<div id="bio-panel" class="bio-panel">' +
			'<div class="bio-ops" id="bio-ops">' +
			'<button type="button" class="bio-op" data-modo="cara">' + ICONO_CARA + "<span>Cara</span></button>" +
			'<button type="button" class="bio-op" data-modo="huella">' + ICONO_HUELLA + "<span>Huella</span></button>" +
			"</div>" +
			'<div class="bio-cam" id="bio-cam"><div class="bio-marco" id="bio-marco">' +
			'<video id="bio-video" playsinline muted autoplay></video>' +
			'<div class="bio-barrido"></div><div class="bio-spinner" id="bio-spinner"></div>' +
			"</div></div>" +
			'<div class="bio-estado" id="bio-estado"></div>' +
			'<button type="button" class="bio-cancelar" id="bio-cancelar">Cancelar</button></div>';
		caja.appendChild(wrap);

		// Con el acceso biometrico disponible, el enlace de inicio de sesion por
		// correo sobra y ademas depende de que llegue el correo. Se oculta solo
		// aqui (si el boton no se pinta, la opcion sigue intacta).
		var porCorreo = document.querySelector("a.btn-login-option.btn-login-with-email-link");
		if (porCorreo) porCorreo.style.display = "none";

		// Frappe agrupa esas opciones en .social-logins con su propio separador
		// "o". Si al ocultar el enlace no queda ninguna opcion visible, se oculta
		// el bloque entero: si no, su "o" se queda huerfana junto a la nuestra.
		var bloqueOpciones = document.querySelector(".social-logins");
		if (bloqueOpciones) {
			var quedan = Array.from(bloqueOpciones.querySelectorAll("a, button"))
				.filter(function (n) { return n.style.display !== "none"; });
			if (!quedan.length) bloqueOpciones.style.display = "none";
		}

		el.principal = wrap.querySelector("#bio-main");
		el.panel = wrap.querySelector("#bio-panel");
		el.ops = wrap.querySelector("#bio-ops");
		el.cam = wrap.querySelector("#bio-cam");
		el.marco = wrap.querySelector("#bio-marco");
		el.video = wrap.querySelector("#bio-video");
		el.spinner = wrap.querySelector("#bio-spinner");
		el.estado = wrap.querySelector("#bio-estado");

		el.principal.addEventListener("click", function () {
			el.principal.classList.add("oculto");
			el.panel.classList.add("abierto");
			decir("");
		});

		wrap.querySelector("#bio-cancelar").addEventListener("click", function () {
			apagar_camara();
			el.ops.classList.remove("oculto");
			el.panel.classList.remove("abierto");
			decir("");
			setTimeout(function () { el.principal.classList.remove("oculto"); }, 180);
		});

		wrap.querySelectorAll(".bio-op").forEach(function (b) {
			b.addEventListener("click", function () {
				if (b.dataset.modo === "cara") {
					if (!window.isSecureContext) return decir("La cámara necesita HTTPS.", "error");
					abrir_camara();
				} else {
					entrar_con_huella(b);
				}
			});
		});
	}

	fetch("/api/method/iopgps_sync.turnos.registro_pc.equipo_autorizado?serial=" + encodeURIComponent(serial),
		{ credentials: "same-origin" })
		.then(function (r) { return r.json(); })
		.then(function (j) {
			if (!j || !j.message || !j.message.ok) return;
			// El formulario puede montarse tarde segun como se haya llegado a la
			// pagina (raiz, /login, con hash). Se reintenta unos segundos en vez
			// de rendirse en el primer vistazo.
			var intentos = 0;
			var montar = function () {
				pintar();
				if (!document.getElementById("bio-wrap") && ++intentos < 20) setTimeout(montar, 300);
			};
			if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", montar);
			else montar();
			// y si la navegacion cambia el hash sin recargar (…/#login)
			window.addEventListener("hashchange", function () { intentos = 0; montar(); });
		})
		.catch(function () {});
})();
